var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleSkipped(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.61 38.61a19 19 0 110-38 19 19 0 010 38zm8.5-12.9l-7.55-5.8a.3.3 0 00-.47.36l1.41 3.58h-3.29a4.43 4.43 0 01-4.42-4.42v-1.07a4.43 4.43 0 014.42-4.43h8.21v-3.79h-8.2A8.22 8.22 0 0010 18.36v1.07a8.22 8.22 0 008.21 8.21h3.18v.02l.21-.01v.16l-1.51 3.84a.3.3 0 00.47.36l7.55-5.8a.3.3 0 000-.49z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--skipped-13078f20e7596b58c5c58d2936392191.svg";
export { SvgIconCircleSkipped as Component };